


import BasicList from "../../../basic-list";

export default class UserPositions extends BasicList {

}